import { SYNC_REPEATERS, SYNC_REPEATERS_REVIEW } from './';

export default (parentKey, childrenKeys, syncKeys, isActive = true) => ({
  type: isActive ? SYNC_REPEATERS : SYNC_REPEATERS_REVIEW,
  payload: { parentKey, childrenKeys, syncKeys },
});
